import {
  IFluxoAdminModeloForm,
  IFluxoAdminModeloRegistro,
} from '../../modules/types/FluxoAdmin';
import httpClient from '../httpClient';

const API_BASE = '/api/fluxoadmmodelos';

export const getAllFluxoAdminModelos = async (): Promise<
  IFluxoAdminModeloRegistro[]
> => {
  const response = await httpClient.get(API_BASE);

  return Array.isArray(response.data?.registros) ? response.data.registros : [];
};

export const getFluxoAdminModeloById = async (
  id: string | number,
): Promise<IFluxoAdminModeloRegistro> => {
  const response = await httpClient.get(`${API_BASE}/${id}`);
  return response.data;
};

export const handleCreateFluxoAdminModelo = async (
  form: IFluxoAdminModeloForm,
): Promise<any> => {
  const response = await httpClient.post(API_BASE, form);
  return response.data;
};

export const handleUpdateFluxoAdminModelo = async (
  form: IFluxoAdminModeloForm,
): Promise<any> => {
  const response = await httpClient.patch(`${API_BASE}/${form.id}`, form);
  return response.data;
};

export const handleDeleteFluxoAdminModelo = async (
  id: string | number,
): Promise<any> => {
  const response = await httpClient.delete(`${API_BASE}/${id}`);
  return response.data;
};
